import { createContext, useContext } from 'react'

import { AccountContext } from 'types/AccountContext'

const context = createContext<AccountContext>({ setSelectedAccountKey: () => {} })
export const useAccountContext = (): AccountContext => useContext(context)
export default context
